module.exports = __webpack_public_path__ + "static/img/hero-bg-960.5a6bfc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/hero-bg-960.jpg
// module id = DiQV
// module chunks = 1